(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var links = document.querySelectorAll('a.arcvsh-shop-entry[href*="view=store"], a[data-arcvsh-store-entry][href*="view=store"]');
    if (!links.length) return;

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (event.defaultPrevented) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        event.preventDefault();
        var destination = link.href;
        var prefetch = document.createElement('link');
        prefetch.rel = 'prefetch';
        prefetch.href = destination;
        document.head.appendChild(prefetch);
        var portal = document.createElement('div');
        portal.className = 'arcvsh-entry-transition';
        portal.setAttribute('aria-hidden', 'true');
        portal.innerHTML =
          '<div class="arcvsh-entry-reveal"><span>ARCVSH</span><small>Explore the complete wardrobe</small></div>' +
          '<div class="arcvsh-entry-door arcvsh-entry-door--left"></div>' +
          '<div class="arcvsh-entry-door arcvsh-entry-door--right"></div>' +
          '<div class="arcvsh-entry-title"><span>ARCVSH by Pallavi Singh</span><strong>Online Store</strong></div>';
        document.body.appendChild(portal);
        document.body.classList.add('arcvsh-transition-active');

        window.requestAnimationFrame(function () {
          portal.classList.add('is-visible');
          window.setTimeout(function () { portal.classList.add('is-opening'); }, 700);
          window.setTimeout(function () { window.location.href = destination; }, 3550);
        });
      });
    });
  });
})();
